/// <amd-module name="Wit/HtmlEditor/index" />

export { HtmlEditor, IHtmlEditorProps } from "./Components/HtmlEditor";
